import { render } from "./AccountNumber.vue?vue&type=template&id=b3547704"
import script from "./AccountNumber.vue?vue&type=script&lang=js"
export * from "./AccountNumber.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__